import { extractApiErrorMessage } from './extractApiErrorMessage';

import { showErrorToast } from './toastStore';

export const showApiErrorToast = (
  error: unknown,
  fallback = 'Ocorreu um erro inesperado.',
) => {
  showErrorToast(extractApiErrorMessage(error, fallback));
};
